import React, {useEffect, useRef, useState} from 'react'
import {CustomSelectStyled} from "./CustomSelect.styled";
import {useClickOutside} from "../../hooks/ClickOutside";
import SimpleBar from "simplebar-react";
import {Translate} from "../translate/Translate";
import {useTranslation} from "react-i18next";

interface ICustomSelectProps {
    list: any[]
    setSelectedItem?: any
    selectValue?: any
    defaultValue?: any
    scrollNumber?: number
    onChange?: any
    tabIndex?: number
    className?: string
    headText?: string
    disabled?: boolean
}

export const CustomSelect: React.FC<ICustomSelectProps> = ({
                                                               setSelectedItem,
                                                               defaultValue,
                                                               selectValue,
                                                               scrollNumber,
                                                               onChange,
                                                               tabIndex,
                                                               className,
                                                               headText,
                                                               disabled,
                                                               ...props
                                                           }) => {



    const [isOpenSelect, setIsOpenSelect] = useState(false)
    const [selectedItemLocal, setSelectedItemLocal]: any = useState((defaultValue && Object.keys(defaultValue).length) ? defaultValue : props.list[0])
    const [countForScrollToSelected, setCountForScrollToSelected] = useState(0)
    const [list, setList] = useState(props.list)
    const [isSet, setIsSet] = useState(false)

    useEffect(() => {
        // Only update if list actually changed (compare by length and first item)
        if (props.list?.length !== list?.length || 
            JSON.stringify(props.list?.[0]) !== JSON.stringify(list?.[0])) {
            setList(props.list)
        }
    }, [props.list])
    
    
    useEffect(() => {
        if(isSet) return;
        const newValue = (defaultValue && Object.keys(defaultValue).length) ? defaultValue : props.list?.[0];
        if (newValue && JSON.stringify(newValue) !== JSON.stringify(selectedItemLocal)) {
            setSelectedItemLocal(newValue)
        }
        
        setTimeout(() => {
            setIsSet(true)
        }, 500)
    }, [props.list, defaultValue])


    const selectBodyRef: any = useRef(null)

    const {rootEl} = useClickOutside(setIsOpenSelect)

    const handleSelect = (item: any) => {
        console.log(item);
        
        setSelectedItemLocal(item)
        if (setSelectedItem) {
            setSelectedItem(item)
        }
    }
    

    // useEffect(() => {
    //     setSelectedItemLocal((defaultValue && Object.keys(defaultValue).length) ? defaultValue : list[0])
    // }, [list])

    useEffect(() => {
        if (selectBodyRef.current?.getScrollElement) {
            selectBodyRef.current.getScrollElement().scrollTop = countForScrollToSelected === 0 ? scrollNumber : countForScrollToSelected
        }
    }, [isOpenSelect, selectedItemLocal])

    useEffect(() => {
        // Only update if selectValue is defined and different
        if (selectValue !== undefined && selectValue !== null) {
            if (JSON.stringify(selectValue) !== JSON.stringify(selectedItemLocal)) {
                setSelectedItemLocal(selectValue)
            }
        }
    }, [selectValue])

    const handleSelectItem = (item: any, index?: number) => {
        handleSelect(item)

        setInputValue(item.value)
        setTimeout(() => {
            setIsOpenSelect(false)
        }, 50)

        tabIndex && inputBlockRef.current.focus()

        if (index) setCountForScrollToSelected(+index * +liItemBlock.current.clientHeight)

        if (onChange) {
            onChange(item)
        }
    }

    const liItemBlock: any = useRef(null)

    const [isPositionTop, setIsPositionTop] = useState(false)

    useEffect(() => {

        setTimeout(() => {
            if (rootEl?.current?.getBoundingClientRect().bottom + 300 > window.innerHeight) setIsPositionTop(true)
        }, 1000)

        setSelectedItemLocal(headText ?? (defaultValue && Object.keys(defaultValue).length) ? defaultValue : list[0])

    }, [])

    const handleOpenSelect = (e: React.MouseEvent<HTMLButtonElement> | React.MouseEvent<HTMLInputElement>) => {
        e.preventDefault()
        setIsOpenSelect(prev => !prev)
        if (!isOpenSelect)
            inputBlockRef?.current?.focus()
    }

    const handleFocusElement = (e: React.ChangeEvent<HTMLInputElement>) => {
        e.preventDefault()
        setIsOpenSelect(true)
    }

    const inputBlockRef: any = useRef(null);

    const whoHaveTranslate = ["team_lead", "project_lead", "employee"]
    const isHaveTranslate = (item: string) => {
        return whoHaveTranslate.some(item2 => item2 === item)
    }

    const isLabelProject = className === "allProjects"

    const [inputValue, setInputValue] = useState(selectValue?.value ?? selectedItemLocal?.value);

    useEffect(() => {
        setInputValue(selectValue?.value ?? selectedItemLocal?.value)
    }, [selectValue])

    const handleChangeInput = (e: React.ChangeEvent<HTMLInputElement>) => {
        setInputValue(e.target.value)
        setSelectedItem({
            label: e.target.value,
            value: e.target.value
        })
    }

    return (
        <CustomSelectStyled ref={rootEl} className={`select ${disabled && "disabled"} ${isOpenSelect && "is-active"} ${className}`}>
            <button type={"button"} onClick={handleOpenSelect} className={`custom-select__head`}>
                {/*{*/}
                {/*    tabIndex &&*/}
                {/*        <input tabIndex={tabIndex} style={{width: "20px"}} type="text"*/}
                {/*               placeholder={selectedItemLocal}/>*/}
                {/*}*/}

                {tabIndex && <input type="text" maxLength={5} onChange={handleChangeInput} value={inputValue} ref={inputBlockRef} tabIndex={tabIndex}
                                    onClick={handleOpenSelect} onFocus={handleFocusElement}/>}

                {!tabIndex && <>
                    {(!headText || selectedItemLocal?.value)
                        ? <span>
                        {
                            isHaveTranslate(selectedItemLocal?.value) ?
                                <Translate>{`employees_admin.table.${selectedItemLocal?.value}`}</Translate> : isLabelProject ? selectedItemLocal?.label.slice(0, selectedItemLocal?.label.indexOf(" -")) : selectedItemLocal?.label
                        }
                    </span> : headText
                    }
                </>}



                <svg className="ss-arrow" viewBox="0 0 100 100">
                    <path d="M10,30 L50,70 L90,30" fill={"transparent"}/>
                </svg>
            </button>
            <SimpleBar ref={selectBodyRef}
                       className={`custom-select__body ${isPositionTop && "custom-select__body_top"}`}>
                <ul>

                    {
                        list.map((item, index: number) =>
                            <li ref={liItemBlock} key={item.value} onClick={_ => handleSelectItem(item, index)}
                                className={selectedItemLocal?.value === item.value ? "li-active" : ""}>
                                {
                                    isHaveTranslate(item.value) ?
                                        <Translate>{`employees_admin.table.${item.value}`}</Translate> : item.label
                                }
                            </li>
                        )
                    }

                </ul>
            </SimpleBar>
        </CustomSelectStyled>
    )
}
